export enum WorkspaceFlavour {
  DNB_CLOUD = 'dnb-cloud',
  LOCAL = 'local',
}
